import styled from 'styled-components'

import theme, { FontFamily, ScreenBreakpoints } from '../../theme'

const TypographyWrapper = styled.span`
  font-family: ${FontFamily.primary};
  font-style: normal;
  font-weight: 400;

  &.h1 {
    font-size: 56px;
    line-height: 64px;
  }

  &.h2 {
    font-size: 46px;
    line-height: 54px;

    @media (max-width: ${ScreenBreakpoints.small}px) {
      font-size: 36px;
      line-height: 46px;
    }
  }

  &.h3 {
    font-size: 38px;
    line-height: 46px;
  }

  &.xl {
    font-size: 30px;
    line-height: 38px;

    @media (max-width: ${ScreenBreakpoints.small}px) {
      font-size: 24px;
      line-height: 32px;
    }
  }

  &.l {
    font-size: 24px;
    line-height: 32px;

    @media (max-width: ${ScreenBreakpoints.small}px) {
      font-size: 20px;
      line-height: 26px;
    }
  }

  &.m {
    font-size: 20px;
    line-height: 28px;

    @media (max-width: ${ScreenBreakpoints.small}px) {
      font-size: 18px;
      line-height: 22px;
    }
  }

  &.body {
    font-size: 16px;
    line-height: 24px;
  }

  &.s {
    font-size: 14px;
    line-height: 22px;
  }

  &.xs {
    font-size: 12px;
    line-height: 20px;
  }

  &.bold {
    font-weight: ${theme.fontWeights.semiBold};
  }
`
export { TypographyWrapper }
